import { useQueryParams } from '../../../hooks/useQueryParams';

export interface DashboardTransacFiltersQueryParams {
  idBranch?: string[];
  idMerchant?: string[];
}

const initialFilters: DashboardTransacFiltersQueryParams = {
  idMerchant: [],
  idBranch: [],
};

/**
 * Filtro de comercio/sucursal del dashboard (usado por `DashboardFilters` y propagado a
 * `TransactionBarChart`/`DashboardDonutChart`). Ya no trae datos por sí mismo: cada
 * gráfica hace su propia consulta a `/transactions-view` con el rango de fecha que le
 * corresponde (ver `useTransactionBarChartData`/`useTransactionsFilterByDateApi`), así
 * que este hook solo administra el estado de idMerchant/idBranch.
 */
export const useDashboardTransactionFilters = () => {
  const {
    queryParams,
    setParam,
    updateParams
  } = useQueryParams<DashboardTransacFiltersQueryParams>(initialFilters);

  const search = (key: keyof DashboardTransacFiltersQueryParams, value: any) => {
    setParam(key, value);
  };

  return {
    queryParams,
    search,
    updateParams
  };
}
